import { render } from "./StatisticsPdfTitle.vue?vue&type=template&id=76fc84ca&ts=true"
import script from "./StatisticsPdfTitle.vue?vue&type=script&lang=ts"
export * from "./StatisticsPdfTitle.vue?vue&type=script&lang=ts"

import "./StatisticsPdfTitle.vue?vue&type=style&index=0&id=76fc84ca&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__